import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import CircularProgress from '@mui/material/CircularProgress';
import { unidadMedida } from "../../utils/default";

const firestore = getFirestore();

function EditPrices() {
    let { id } = useParams();
    const [state, setState] = useState({
        id: id,
        descripcion: '',
        unidad_medida: "Unitario",
        hogar: "",
        corporativo: "0",
        feriado_domingo_hogar: "",
        feriado_domingo_corporativo: "0",
        montoFijo: false,
        montoFijoValor: "",
        montoFijoFeriadoValor: "",
        submitted: false,
        spinner: true,
    });

    useEffect(() => {
        loadPriceData();
    }, [id]);

    const loadPriceData = async () => {
        try {
            const priceDocRef = doc(firestore, 'precios', String(id));
            const priceSnap = await getDoc(priceDocRef);

            if (priceSnap.exists()) {
                const val = priceSnap.data();
                setState(prevState => ({
                    ...prevState,
                    id: val.id !== undefined ? val.id : id,
                    descripcion: val.descripcion || '',
                    unidad_medida: val.unidad_medida || 'Unitario',
                    hogar: val.hogar !== undefined ? val.hogar : '',
                    corporativo: val.corporativo !== undefined ? val.corporativo : '0',
                    feriado_domingo_hogar: val.feriado_domingo_hogar !== undefined ? val.feriado_domingo_hogar : '',
                    feriado_domingo_corporativo: val.feriado_domingo_corporativo !== undefined ? val.feriado_domingo_corporativo : '0',
                    montoFijo: val.montoFijo === true || val.montoFijo === "true",
                    montoFijoValor: val.montoFijoValor !== undefined ? String(val.montoFijoValor) : (val.hogar || ''),
                    montoFijoFeriadoValor: val.montoFijoFeriadoValor !== undefined ? String(val.montoFijoFeriadoValor) : (val.feriado_domingo_hogar || val.montoFijoValor || val.hogar || ''),
                    spinner: false,
                }));
            } else {
                setState(prevState => ({ ...prevState, spinner: false }));
            }
        } catch (error) {
            console.error("Error al cargar datos del precio:", error);
            setState(prevState => ({ ...prevState, spinner: false }));
        }
    };

    const onChangeValues = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setState(prevState => ({ ...prevState, [name]: value }));
    };

    const onChangeUnidadMedida = (e) => {
        setState(prevState => ({ ...prevState, unidad_medida: e.target.value }));
    };

    const updatePrices = async () => {
        try {
            setState(prevState => ({ ...prevState, spinner: true }));
            const data = {
                id: Number(state.id),
                descripcion: state.descripcion,
                unidad_medida: state.unidad_medida,
                hogar: String(state.hogar),
                corporativo: String(state.corporativo || "0"),
                feriado_domingo_hogar: String(state.feriado_domingo_hogar || state.hogar),
                feriado_domingo_corporativo: String(state.feriado_domingo_corporativo || "0"),
                montoFijo: state.montoFijo === true,
                montoFijoValor: String(state.montoFijoValor || state.hogar || "0"),
                montoFijoFeriadoValor: String(state.montoFijoFeriadoValor || state.feriado_domingo_hogar || state.montoFijoValor || "0"),
            };

            await setDoc(doc(firestore, "precios", String(state.id)), data, { merge: true });

            // También actualizar la descripción en 'servicios'
            try {
                await setDoc(doc(firestore, "servicios", String(state.id)), { name: state.descripcion }, { merge: true });
            } catch (err) {
                console.warn("No se pudo actualizar servicios doc:", err);
            }

            setState(prevState => ({
                ...prevState,
                submitted: true,
                spinner: false,
            }));
        } catch (error) {
            console.error("Error al guardar precio:", error);
            setState(prevState => ({ ...prevState, spinner: false }));
        }
    };

    return (
        <Container component="main" maxWidth="xs" sx={{ mt: 4, mb: 4 }}>
            {state.submitted ? (
                <div>
                    <Typography variant="h4" sx={{ mb: 2 }}>¡Precios editados correctamente!</Typography>
                    <Button variant="contained" href="/prices">
                        Ir a listado
                    </Button>
                </div>
            ) : (
                <div className="form-container">
                    {state.spinner ? (
                        <CircularProgress />
                    ) : (
                        <>
                            <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
                                Editar Precios (ID: {id})
                            </Typography>
                            <div className="order-container">
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            className="default__textfield"
                                            id="descripcion"
                                            label="Descripción"
                                            value={state.descripcion}
                                            name="descripcion"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputLabel>Unidad de medida</InputLabel>
                                        <Select
                                            onChange={onChangeUnidadMedida}
                                            value={state.unidad_medida}
                                            className="select__form"
                                            fullWidth
                                        >
                                            {unidadMedida.map((tipo) => (
                                                <MenuItem key={tipo} value={tipo}>
                                                    {tipo}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            className="default__textfield"
                                            id="hogar"
                                            label="Precio Cliente Hogar (Gs.)"
                                            value={state.hogar}
                                            name="hogar"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            className="default__textfield"
                                            id="feriado_domingo_hogar"
                                            label="Precio Cliente Feriado/Domingo (Gs.)"
                                            value={state.feriado_domingo_hogar}
                                            name="feriado_domingo_hogar"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={state.montoFijo}
                                                    onChange={(e) => setState(prev => ({
                                                        ...prev,
                                                        montoFijo: e.target.checked,
                                                        montoFijoValor: e.target.checked && !prev.montoFijoValor ? prev.hogar : prev.montoFijoValor,
                                                        montoFijoFeriadoValor: e.target.checked && !prev.montoFijoFeriadoValor ? (prev.feriado_domingo_hogar || prev.hogar) : prev.montoFijoFeriadoValor
                                                    }))}
                                                    color="primary"
                                                />
                                            }
                                            label="Activar Monto Fijo (Cuadrilla)"
                                        />
                                    </Grid>
                                    {state.montoFijo && (
                                        <>
                                            <Grid item xs={12}>
                                                <TextField
                                                    variant="outlined"
                                                    required
                                                    fullWidth
                                                    className="default__textfield"
                                                    id="montoFijoValor"
                                                    label="Monto Fijo Semana (Gs.)"
                                                    value={state.montoFijoValor}
                                                    name="montoFijoValor"
                                                    onChange={onChangeValues}
                                                    helperText="Monto en días hábiles que cobrará la cuadrilla por este servicio"
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    variant="outlined"
                                                    required
                                                    fullWidth
                                                    className="default__textfield"
                                                    id="montoFijoFeriadoValor"
                                                    label="Monto Fijo Domingo / Feriado (Gs.)"
                                                    value={state.montoFijoFeriadoValor}
                                                    name="montoFijoFeriadoValor"
                                                    onChange={onChangeValues}
                                                    helperText="Monto en domingos o feriados que cobrará la cuadrilla por este servicio"
                                                />
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                                <Button
                                    type="button"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className="button__save"
                                    onClick={updatePrices}
                                    sx={{ mt: 3 }}
                                >
                                    Guardar Cambios
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            )}
        </Container>
    );
}

export default EditPrices;
